import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Action, Badge } from 'hljd'
import { inject } from 'mobx-react'
import List from './List'
import { Button } from 'hljd'
import { hashHistory } from 'react-router'
import { HOTEL_MENU_RANKING_PATH } from '@components/Hotel/constant'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { onChange, keys, toLink, unAuditNumber } = this.props.store
    return (
      <>
        <Action
          options={[
            { title: '已上架', value: '1' },
            { title: '审核中', value: '2' },
            {
              title: (
                <Badge count={unAuditNumber} offset={[10, -5]}>
                  <span style={{ fontSize: '16px' }}>审核未通过</span>
                </Badge>
              ),
              value: '3'
            },
            { title: '已下架', value: '4' }
          ]}
          active={keys + ''}
          onChange={onChange}
          extra={
            <>
              {keys == 1 && (
                <Button
                  type="primary"
                  onClick={() => hashHistory.push(HOTEL_MENU_RANKING_PATH)}
                  style={{ marginRight: 20 }}
                >
                  菜单排序
                </Button>
              )}

              <Button onClick={toLink}>发布菜单</Button>
            </>
          }
        />

        <List />
      </>
    )
  }
}
